import {useContext} from "react";
import {HalfwayContext} from "../../context/HalfwayContext";
import {HalfwayContextType} from "../../types/HalfwayContextType";

export const Incrementer = () => {

    const {
        productDrawerMenuItem,
        setProductDrawerMenuItem
    } = useContext(HalfwayContext) as HalfwayContextType;

    const changeTotalInBasket = (increment: boolean) => {
        let newTotal: number;
        if (increment)
        {
            newTotal = (productDrawerMenuItem?.totalInBasket ?? 0) + 1;
        }
        else
        {
            newTotal = (productDrawerMenuItem?.totalInBasket ?? 0) === 0
                ? 0
                : (productDrawerMenuItem?.totalInBasket ?? 0) - 1;
        }

        setProductDrawerMenuItem(prevState => ({
                ...prevState,
                totalInBasket: newTotal
            }));
    }

    return(
        <div className="confirm_input-wrapper">
            <button className="confirm-control-minus"
                    type='button'
                    aria-label='Decrease quantity'
                    onClick={() => changeTotalInBasket(false)}>
                <div className="icon-embed-small w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                         fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                         aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </div>
            </button>

            <span className="confirm_input">{productDrawerMenuItem?.totalInBasket ?? 0}</span>

            <button className="confirm-control-add"
                    type='button'
                    aria-label='Increase quantity'
                    onClick={() => changeTotalInBasket(true)}>
                <div className="icon-embed-small w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                         fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                         aria-hidden="true">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </div>
            </button>
        </div>
    )
}
